import { conditionalArrayItem } from 'BMapsSrc/util/js_utils';
import { BackgroundColors, DefaultBackgroundColor } from '../../themes';
import { DefaultBindingSiteRadius } from '../../utils';

export const PREFS_TYPE = {
    boolean: 'boolean',
    enum: 'enum',
    int: 'int',
};

export const preferences = [
    {
        id: 'ShowCommandData',
        label: 'Show Command Data',
        type: PREFS_TYPE.boolean,
        default: false,
        availability: 'lab',
    },
    {
        id: 'DontPromptBeforeExit',
        label: "Don't Prompt Before Exit",
        type: PREFS_TYPE.boolean,
        default: false,
        availability: 'lab',
    },
    {
        id: 'MinimizationEngine',
        label: 'Minimization Engine',
        type: PREFS_TYPE.enum,
        // 'Local' routes the interactive MM minimization path to the in-browser
        // engine. MM and BFD remain the server-backed options. Default is MM.
        values: [
            { id: 'MM', label: 'OpenMM' },
            { id: 'BFD', label: 'Legacy Bioleap Energies' },
            { id: 'Local', label: 'In-Browser (experimental)', availability: 'lab' },
        ],
        default: 'MM',
    },
    {
        id: 'EnergyEngine',
        label: 'Energy Calculation Engine',
        type: PREFS_TYPE.enum,
        values: [{ id: 'MM', label: 'OpenMM' }, { id: 'BFD', label: 'Legacy Bioleap Energies' }],
        default: 'MM',
    },
    {
        id: 'Forcefield',
        label: 'Forcefield',
        type: PREFS_TYPE.enum,
        values: [{ id: 'Amber', label: 'Amber' }, { id: 'OpenFF', label: 'OpenFF' }],
        default: 'Amber',
        availability: 'lab',
    },
    {
        id: 'FragmentLoading',
        label: 'Fragment loading strategy',
        type: PREFS_TYPE.enum,
        values: [
            { id: 'greedy', label: 'Load default fragments with protein' },
            { id: 'lazy', label: 'Manually load fragments with Fragment Manager' },
        ],
        default: 'greedy',
    },
    {
        id: 'MaxMolecules',
        label: 'Max. molecules to load from SDF',
        type: PREFS_TYPE.int,
        default: 100,
    },
    {
        id: 'UseAlignment',
        label: 'Align selectivity proteins to first loaded protein',
        type: PREFS_TYPE.boolean,
        default: true,
    },
    {
        id: 'ColorScheme',
        label: 'Color Scheme',
        type: PREFS_TYPE.enum,
        values: Object.keys(BackgroundColors).map((v) => ({ id: v, label: v })),
        default: DefaultBackgroundColor,
    },
    {
        // TODO: consider introducing a float preference type and a "step" option
        // Binding site radius steps by 0.5 with the mousewheel
        id: 'BindingSiteDistance',
        label: 'Binding Site Distance (Å)',
        type: PREFS_TYPE.int,
        default: DefaultBindingSiteRadius,
    },
    {
        id: 'UseAutoGiFE',
        label: 'Request GiFE energies automatically',
        type: PREFS_TYPE.boolean,
        default: false,
        availability: 'lab',
    },
    {
        id: 'UseAutoExternalProperties',
        label: 'Fetch external properties when loading compounds',
        type: PREFS_TYPE.boolean,
        default: true,
    },
    {
        id: 'PiPiAlgorithm',
        label: 'Pi-Pi Identification Algorithm',
        type: PREFS_TYPE.enum,
        values: [{ id: 'bmaps', label: 'BMaps' }, { id: 'prolif', label: 'ProLIF LID' }],
        default: 'prolif',
    },
    {
        id: 'ProteinPdbMethod',
        label: 'Protein PDB Method',
        type: PREFS_TYPE.enum,
        values: [{ id: 'local', label: 'Local BMaps' }, { id: 'server', label: 'BMaps Server' }],
        default: 'local',
        availability: 'lab',
    },
    {
        id: 'UseMockServiceWorker',
        label: 'Use Mock Service Worker',
        type: PREFS_TYPE.boolean,
        default: false,
        availability: 'dev',
    },
];
